// extracted by mini-css-extract-plugin
export default {"scrollContainer":"LogoCollection_scrollContainer__I1h8O","scroll":"LogoCollection_scroll__Lr0+r"};